export const dangerColor = "#FA3934"
export const lightTextColor = "#737791"
